module.exports = __webpack_public_path__ + "img/right-nav-one.e2d924fb.png";